import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    /* overflow: ${({$isTourOpen}) => ($isTourOpen ? 'hidden !important' : 'visible')}; */
    padding: 0 10px;
    width: 100%;

    @media (min-width: 720px) {
        margin: 40px 0 0 100px;
    }
    
    
    @media (min-width: 1100px) {
        margin: 0 0 0 200px;
        padding: 40px 140px 0;
    }

    div.header {
        align-items: flex-end;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    div.buttons-container {
        display: flex;
        flex: 0 0 auto;
        flex-wrap: nowrap;
        gap: 20px;
        height: fit-content;
        margin: 20px 0;
        overflow-x: scroll;
        scrollbar-width: none;
        width: 100%;
        white-space: nowrap;

        -ms-overflow-style: none;

        @media (min-width: 720px) {
            gap: 40px;
            overflow-x: hidden;
        }

        button {
            flex: 0 0 auto;
            white-space: nowrap;
            width: 280px;
        }
    }

    div.data-container {
        background: #FCFCFC;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin: auto;
        width: 100%;
    }
`;

export const Icon = styled(SVG)`
    background: #FFFFFF;
    border: none;
    height: 24px;
    width: 24px;

    @media (min-width: 720px) {
        height: 18px;
        width: 18px;
    }
`;

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 10px 0;
    text-align: center;
    width: 100%;
`;

export const TitleContainer = styled.div`
    width: 100%;
`;

export const LastUpdateContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 5px;
    justify-content: flex-end;
    width: 100%;
`;

export const LastUpdateIcon = styled(SVG)`
    height: 18px;
    width: 18px;
`;

export const LastUpdateText = styled.span`
    align-items: center;
    color: #333;
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 5px;
    justify-content: center;
    line-height: normal;
    text-align: center;
    white-space: nowrap;
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    @media (min-width: 1100px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: flex-start;
    }

    .personal-data {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        width: auto;
        
        @media (min-width: 1100px) {
            flex-direction: row;
            width: 70%;
        }

        .input-column{
            width: 100%;
            @media (min-width: 1100px) {
                width: 45%;
            }
        }
    }
`;

export const FromContainer = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 20px;
    width: 80%;
    @media (min-width: 1100px) {
        width: 30%;
    }

    div#confirm-email {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
    }
`;

export const ImageIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: currentColor;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 25px;
    justify-content: center;
    padding-bottom: 150px;
    width: 100%;
    @media (min-width: 1100px) {
        align-self: flex-end;
        justify-content: flex-end;
        margin-right: 10%;
        padding: 20px;
        width: 100%;
    }
`;

export const ButtonsModal = styled.div`
    display: flex;
    gap: 25px;
    justify-content: space-between;
    width: 100%;

`;

export const ModalContent = styled.div`
    overflow: ${({$isTourOpen}) => ($isTourOpen ? 'hidden !important' : 'auto')};
    text-align: center;
`;

export const ModalText = styled.span`
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
`;

export const QrcodeImage = styled.img`
    display: flex;
    height: 155px;
    width: 155px;
`;

export const QrcodeContainer = styled.div` 
    align-items: center;
    background: #ECECEC;
    border-radius: 6.784px;
    display: flex;
    justify-content: center;
    margin: 20px auto;
    padding: 15px;
    width: fit-content;
`;

export const InputContainer = styled.div`
    display: flex;
    gap: 30px;
    margin: 16px auto 0 auto;
    width: 80%;
`;

export const BackupCodeContainer = styled.div`
    align-items: center;
    border: 1px solid #006560;
    border-radius: 5px;
    color: #333;
    display: flex;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    margin: 5px;
    padding: 10px;
    text-align: center;
    width: 85%;
`;

export const BackupCodesContainer = styled.button`
    align-items: center;
    background: #FFFFFF;
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    outline: none;
    padding: 5px;
    width: 100%;
`;

export const ContainerCheckbox = styled.form`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: start;
    margin-top: 20px;
    width: 100%;
`;

export const TitleEquipament = styled.h1`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    width: 100%;
`;

export const NumberInput = styled.input`
    align-items: center;
    background: #FFFFFF;
    border: 1.14px solid #C4C4C4;
    border-radius: 3.802px;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: #333;
    display: flex;
    font-size: 15px;
    font-style: normal;
    font-weight: 600; 
    height: 24px;
    justify-content: center;
    line-height: 0;
    outline: none;
    text-align: center;
    width: 48px;
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
`;

export const Text = styled.span`
    align-items: center;
    background: #FFFFFF;
    color: #333;
    display: flex;
    font-size: 15px;
    font-style: normal;
    font-weight: 600; 
    height: 24px;
    justify-content: center;
    line-height: 0;
    outline: none;
    text-align: center;
`;

export const ContainerInputs = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;    
    gap: 5px; 
    justify-content: flex-start;   
    width: 100%;
`;

export const ColumnContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    margin-bottom: 10px;
    width: 100%;
    @media (min-width: 720px) {
        width: 50%;
    }
`;

export const ContainerVariaveisItem = styled.div`
    background: #FFFFFF;
    display: flex;
    width: 50%;
`;

export const SearchContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    margin-bottom: 10px;
    width: 100%;
`;

export const RowContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 18px;
    justify-content: center;
`;